module.exports = __webpack_public_path__ + "static/founders-17f5979f69b0b0a52634f79e533b0f00.jpg";